import React from "react";

const ContactPage = () => {
  return (
    <div>
      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
        <div className="container py-5">
          <div
            className="section-title text-center position-relative pb-3 mb-5 mx-auto"
            style={{ maxWidth: "600px" }}
          >
            <h5 className="fw-bold text-primary text-uppercase">Contact Us</h5>
            <h1 className="mb-0">
              If You Have Any Query, Feel Free To Contact Us
            </h1>
          </div>

          {/* Contact Info Section */}
          <div className="row g-4 mb-5 text-center text-lg-start">
            {/* Phone */}
            <div className="col-lg-4 col-md-6">
              <div
                className="d-flex align-items-center justify-content-center justify-content-lg-start wow fadeIn"
                data-wow-delay="0.1s"
              >
                <div
                  className="bg-primary d-flex align-items-center justify-content-center rounded-circle"
                  style={{ width: "60px", height: "60px" }}
                >
                  <i className="fa fa-phone-alt text-white fs-4"></i>
                </div>
                <div className="ps-3 text-start">
                  <h5 className="mb-1">Call to ask any question</h5>
                  <a
                    href="tel:8850322403"
                    className="text-primary mb-0 text-decoration-none fw-semibold"
                  >
                    +91 8850322403
                  </a> | 
                   <a
                    href="tel:9167437326"
                    className="text-primary mb-0 text-decoration-none fw-semibold"
                  >
                     +91 9167437326
                  </a>
                </div>
              </div>
            </div>

            {/* Email */}
            <div className="col-lg-4 col-md-6">
              <div
                className="d-flex align-items-center justify-content-center justify-content-lg-start wow fadeIn"
                data-wow-delay="0.4s"
              >
                <div
                  className="bg-primary d-flex align-items-center justify-content-center rounded-circle"
                  style={{ width: "60px", height: "60px" }}
                >
                  <i className="fa fa-envelope-open text-white fs-4"></i>
                </div>
                <div className="ps-3 text-start">
                  <h5 className="mb-1">Email to get free quote</h5>
                  <a
                    href="mailto:info@myeasytaxpropartners.com"
                    className="text-primary mb-0 text-decoration-none fw-semibold"
                  >
                    info@myeasytaxpropartners.com
                  </a>
                </div>
              </div>
            </div>

            {/* Address */}
            <div className="col-lg-4 col-md-12">
              <div
                className="d-flex align-items-center justify-content-center justify-content-lg-start wow fadeIn"
                data-wow-delay="0.8s"
              >
                <div
                  className="bg-primary d-flex align-items-center justify-content-center rounded-circle"
                  style={{ width: "60px", height: "60px" }}
                >
                  <i className="fa fa-map-marker-alt text-white fs-4"></i>
                </div>
                <div className="ps-3 text-start">
                  <h5 className="mb-1">Visit our office</h5>
                  <a
                    href="https://maps.google.com/?q=MyEasyTax, Mumbai, India"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary mb-0 text-decoration-none fw-semibold"
                  >
                    Mumbai, India
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Form + Map Section */}
          <div className="row g-5">
            <div className="col-lg-6 wow slideInUp" data-wow-delay="0.3s">
              <form
                onSubmit={(e) => {
                  e.preventDefault();

                  const formData = new FormData(e.target);
                  fetch("https://localhost:3000/sendMail.php", {
                    method: "POST",
                    body: formData,
                  })
                    .then((res) => res.text())
                    .then((data) => {
                      alert(data);
                      e.target.reset();
                    })
                    .catch((err) => alert("Error sending message: " + err));
                }}
              >
                <div className="row g-3">
                  <div className="col-md-6">
                    <input
                      type="text"
                      name="name"
                      className="form-control border-0 bg-light px-4"
                      placeholder="Your Name"
                      required
                      style={{ height: "55px" }}
                    />
                  </div>
                  <div className="col-md-6">
                    <input
                      type="email"
                      name="email"
                      className="form-control border-0 bg-light px-4"
                      placeholder="Your Email"
                      required
                      style={{ height: "55px" }}
                    />
                  </div>
                  <div className="col-12">
                    <input
                      type="text"
                      name="subject"
                      className="form-control border-0 bg-light px-4"
                      placeholder="Subject"
                      required
                      style={{ height: "55px" }}
                    />
                  </div>
                  <div className="col-12">
                    <textarea
                      name="message"
                      className="form-control border-0 bg-light px-4 py-3"
                      rows="4"
                      placeholder="Message"
                      required
                    ></textarea>
                  </div>
                  <div className="col-12">
                    <button
                      className="btn btn-primary w-100 py-3"
                      type="submit"
                    >
                      Send Message
                    </button>
                  </div>
                </div>
              </form>
            </div>

            <div className="col-lg-6 wow slideInUp" data-wow-delay="0.6s">
              <iframe
                className="position-relative rounded w-100 h-100"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d241316.5041766397!2d72.5671073651181!3d19.082617824348123!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c6306644edc1%3A0x5da4ed8f8d648c69!2sMumbai%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1762946106190!5m2!1sen!2sin"
                style={{ minHeight: "350px", border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Google Map"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
